import React from 'react';

const ThumbsUpIcon = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden="true"
    {...props}
  >
    <g clipPath="url(#clip0_20266_26374)">
      <path
        d="M4.80566 6.7V14.5M10.0057 4.022L9.35566 6.7H13.1452C13.347 6.7 13.546 6.74699 13.7265 6.83724C13.9071 6.9275 14.0641 7.05855 14.1852 7.22C14.3063 7.38145 14.3881 7.56889 14.4242 7.76745C14.4603 7.96601 14.4497 8.17025 14.3932 8.364L12.8787 13.564C12.7999 13.834 12.6357 14.0712 12.4107 14.24C12.1856 14.4088 11.9119 14.5 11.6307 14.5H2.85566C2.51088 14.5 2.18022 14.363 1.93643 14.1192C1.69263 13.8754 1.55566 13.5448 1.55566 13.2V8C1.55566 7.65522 1.69263 7.32456 1.93643 7.08076C2.18022 6.83696 2.51088 6.7 2.85566 6.7H4.64966C4.89152 6.69987 5.12854 6.63228 5.33408 6.50482C5.53963 6.37736 5.70554 6.19509 5.81316 5.9785L8.05566 1.5C8.36219 1.5038 8.66389 1.57681 8.93824 1.71359C9.21258 1.85037 9.45247 2.04737 9.63998 2.28988C9.82749 2.53239 9.95777 2.81414 10.0211 3.11408C10.0844 3.41402 10.0791 3.72439 10.0057 4.022Z"
        stroke="#6E7781"
        strokeWidth={1.25}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_20266_26374">
        <rect width={16} height={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ThumbsUpIcon;
